module.exports = __webpack_public_path__ + "img/btn_lijisuoding@2x.62dedb1b.gif";